import React, { useRef, useState, useEffect, useCallback, memo } from 'react'

import { Tooltip } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { number } from 'prop-types'

import cgtraderIcon from 'images/icons/svg/new_item_page/cgtrader.svg'

import calculateOptimalPlacement from './Utils/calculateOptimalPlacement'

function AutoGeneratedBadge({ index }) {
  const badgeRef = useRef(null)
  const [place, setPlace] = useState('top')
  const [isPageLoaded, setIsPageLoaded] = useState(false)

  const calculatePlacement = useCallback(() => {
    if (!badgeRef.current) {
      return
    }

    const trigger = badgeRef.current.querySelector('[data-tip]')
    if (!trigger) {
      return
    }

    const optimalPlace = calculateOptimalPlacement(trigger)
    setPlace(optimalPlace)
  }, [])

  // Check if page has loaded
  useEffect(() => {
    // Check if already loaded
    if (document.readyState === 'complete') {
      setIsPageLoaded(true)
      return
    }

    // Listen for load event
    const handleLoad = () => {
      setIsPageLoaded(true)
    }

    window.addEventListener('load', handleLoad)

    return () => {
      window.removeEventListener('load', handleLoad)
    }
  }, [])

  // Setup tooltip calculation after page loads
  useEffect(() => {
    if (!isPageLoaded) {
      return
    }

    const element = badgeRef.current
    if (!element) {
      return
    }

    // Calculate on mount
    const timer = setTimeout(calculatePlacement, 0)

    // Recalculate on mouse enter
    const handleMouseEnter = () => {
      calculatePlacement()
    }

    // Recalculate on touch events
    const handleTouchStart = () => {
      calculatePlacement()
    }

    element.addEventListener('mouseenter', handleMouseEnter, { passive: true })
    element.addEventListener('touchstart', handleTouchStart, { passive: true })

    return () => {
      clearTimeout(timer)
      element.removeEventListener('mouseenter', handleMouseEnter)
      element.removeEventListener('touchstart', handleTouchStart)
    }
  }, [calculatePlacement, isPageLoaded])

  return (
    <div
      ref={badgeRef}
      className="gallery-area-thumbs-carousel__auto-generated-badge"
    >
      {isPageLoaded ? (
        <Tooltip
          id={`auto-generated-tooltip-${index}`}
          content="This preview was automatically generated by CGTrader to help you assess the model."
          place={place}
          tooltipClassName="cgt-tooltip--auto-generated"
        >
          <img
            src={cgtraderIcon}
            alt="cgtrader logo"
          />
        </Tooltip>
      ) : (
        <img
          src={cgtraderIcon}
          alt="cgtrader logo"
        />
      )}
    </div>
  )
}

AutoGeneratedBadge.propTypes = {
  index: number.isRequired,
}

export default memo(AutoGeneratedBadge)

